import type { Observable } from 'rxjs'

/** A copy failed; retry only the tasks not confirmed copied. */
export class TaskCopyError extends Error {
  /**
   * Retains the remaining copy batches.
   * @param {unknown} cause The failed request.
   * @param {Observable<void>} retry The remaining copies.
   */
  constructor(
    cause: unknown,
    readonly retry: Observable<void>
  ) {
    super('Some tasks could not be copied.', { cause })
  }
}

/** A related task group cannot fit in one copy request. */
export class TaskCopyBatchLimitError extends Error {}
